import { useState, useEffect } from "react";

export const useDarkMode = (): [boolean, () => void] => {
  // Initialize dark mode with saved preference or system preference immediately
  const [darkMode, setDarkMode] = useState<boolean>(() => {
    const savedThemePreference = localStorage.getItem("darkMode");
    if (savedThemePreference) {
      return JSON.parse(savedThemePreference);
    }
    // Check for system preference
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // Check for user preference in localStorage or system preferences
  useEffect(() => {
    // Listen for system theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e: MediaQueryListEvent) => {
      const savedThemePreference = localStorage.getItem("darkMode");
      if (!savedThemePreference) {
        setDarkMode(e.matches);
      }
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  // Toggle between dark and light mode
  const toggleDarkMode = () => {
    const newMode = !darkMode;
    localStorage.setItem("darkMode", JSON.stringify(newMode)); // Save preference in localStorage
    setDarkMode(newMode);
  };

  return [darkMode, toggleDarkMode];
};
